import React from 'react';
import PropTypes from 'prop-types';

const ResultsCount = ({ count, singular, plural }) => {
  const entityText = count === 1 ? singular : plural;

  return (
    <div style={{
      color: '#64748B',
      fontSize: '14px',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      flexShrink: 0
    }}>
      <span style={{ fontWeight: 600 }}>
        {count}
      </span>
      {entityText} found
    </div>
  );
};

ResultsCount.propTypes = {
  count: PropTypes.number.isRequired,
  singular: PropTypes.string.isRequired,
  plural: PropTypes.string.isRequired,
};

export default ResultsCount;
